import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enAgent from './locales/en/agent.json';
import enAuth from './locales/en/auth.json';
import enCall from './locales/en/call.json';
import enAcw from './locales/en/acw.json';
import enSettings from './locales/en/settings.json';
import enProfile from './locales/en/profile.json';
import enNav from './locales/en/nav.json';
import enActivityLog from './locales/en/activityLog.json';

import deCommon from './locales/de/common.json';
import deAgent from './locales/de/agent.json';
import deAuth from './locales/de/auth.json';
import deCall from './locales/de/call.json';
import deAcw from './locales/de/acw.json';
import deSettings from './locales/de/settings.json';
import deProfile from './locales/de/profile.json';
import deNav from './locales/de/nav.json';
import deActivityLog from './locales/de/activityLog.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        agent: enAgent,
        auth: enAuth,
        call: enCall,
        acw: enAcw,
        settings: enSettings,
        profile: enProfile,
        nav: enNav,
        activityLog: enActivityLog,
      },
      de: {
        common: deCommon,
        agent: deAgent,
        auth: deAuth,
        call: deCall,
        acw: deAcw,
        settings: deSettings,
        profile: deProfile,
        nav: deNav,
        activityLog: deActivityLog,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
